// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"dot-loader_wrapper__KBU7k","animate1":"dot-loader_animate1__1FTh1","animate2":"dot-loader_animate2__23hy4","animate3":"dot-loader_animate3__3d5hE"};